import ScriptListing from "./ScriptListing";

function ScriptManagement() {
  return <ScriptListing />;
}

export default ScriptManagement;
